<template>
  <RevCard class="flex justify-between p-24">
    <div class="flex gap-16">
      <div
        class="border-static-default-low rounded-sm flex h-40 w-40 items-center justify-center border"
      >
        <RevIllustration
          alt=""
          class="h-32 w-32"
          :height="32"
          :src="imageUrl"
          :width="32"
        />
      </div>

      <div class="text-static-default-hi body-1-bold">
        {{
          i18n(translations.giftCardTitle, {
            price: i18n.price(price),
          })
        }}
      </div>
      <div calss="body-2 text-action-default-low mt-4">
        {{ i18n(translations.emailDelivery) }}
      </div>
    </div>
    <div class="body-1">
      {{ i18n.price(price) }}
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import type { Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './GiftCardsSummaryCard.translations'

const i18n = useI18n()

defineProps<{
  price: Price
  imageUrl: string
}>()
</script>
